import { IShip } from '../../../data/types/ship/ship';

export const isOnBoard = (name: string) => (ship: IShip): boolean =>
  ship.crew.some((member) => member.name === name);

export const isWildOnBoard = isOnBoard('Wild');
